<app-pageheader [Parent]="this">
  <add-button AddRoute="/integrations/datafeeds/new/edit"></add-button>
</app-pageheader>

<app-datalistview [Columns]="Columns" [ShowMap]="false" ApiUrl="integrations/datafeeds/searches"
  [AllowEdit]="true" EditUrl="/integrations/datafeeds/:id">
  <app-filter-set>
    <div app-search-filter></div>
    <div app-subset-filter [Subsets]="SubSets" Subset=""></div>
    <div app-search-button></div>
  </app-filter-set>
</app-datalistview> 